import { service } from "@/utils/request";

export default {
  // 获取列表
  get: (params, data) => {
    return service({
      url: "/cloud/course/admin/bestsellCourse/page",
      method: "post",
      data,
      params
    });
  },
  // 获取详情
  getDetails: (id) => {
    return service({
      url: "/cloud/course/admin/bestsellCourse/detail/" + id,
      method: "get"
    });
  },
  // 添加
  edit: (data) => {
    return service({
      url: "/cloud/course/admin/bestsellCourse/add",
      method: "post",
      data
    });
  },
  // 上下架
  changeState: (id, params) => {
    return service({
      url: "/cloud/course/admin/bestsellCourse/updateState/" + id,
      method: "post",
      params
    });
  },
  // 删除
  remove: (id) => {
    return service({
      url: "/cloud/course/admin/bestsellCourse/disEnable/" + id,
      method: "post"
    });
  },
  // 用户明细
  userList: (id, params, data) => {
    return service({
      url: "/cloud/course/admin/bestsellCourse/page/user/" + id,
      method: "post",
      data,
      params
    });
  },
  exportExcel(data) {
    return service({
      url: '/cloud/course/admin/bestsellCourse/export/user/' + data.id,
      method: 'post',
      responseType: 'blob',
      data: data.data
    })
  },
  // 设置入口
  setEntrance(data) {
    return service({
      url: '/cloud/course/admin/sysRoute/add',
      method: 'post',
      data
    })
  },
  // 获取入口
  getEntrance() {
    return service({
      url: '/cloud/course/admin/sysRoute/get/input/bc2/100',
      method: 'get'
    })
  },
  // 修改入口
  editEntrance(data) {
    return service({
      url: '/cloud/course/admin/sysRoute/update',
      method: 'post',
      data
    })
  },
  // 爆款课用户明细
  userDetails(params, data) {
    return service({
      url: '/cloud/course/admin/bc/content/userDetails',
      method: 'post',
      params,
      data
    })
  },
  // 爆款课用户明细导出
  userDetailsExport(data) {
    return service({
      url: '/cloud/course/admin/bc/content/userDetails/export',
      method: 'post',
      responseType: 'blob',
      data: data.data
    })
  },
  // uv列表
  uvList(params, data) {
    return service({
      url: '/cloud/course/admin/bc/content/statistics/list',
      method: 'post',
      params,
      data
    })
  },
  // uv图片
  uvChart(data) {
    return service({
      url: '/cloud/course/admin/bc/content/statistics/chart',
      method: 'post',
      data
    })
  },
  // 修改权重
  updateWeight(bcId, params) {
    return service({
      url: '/cloud/course/admin/bestsellCourse/updateWeight/' + bcId,
      method: 'post',
      params
    })
  },
  // 导出数据
  exportAnlysisExcel(data) {
    return service({
      url: '/cloud/course/admin/bc/content/statistics/list/export',
      method: 'post',
      data,
      responseType: 'blob'
    })
  },
  getDisciplineList: (params) => {
    return service({
      url: '/cloud/course/v1/discipline/list',
      method: 'post',
      params
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/operateManage/hotcourse.js